import { type ReactNode } from "react";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RainbowKitProvider, darkTheme } from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";
import { config } from "../config/wagmi";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchInterval: 10_000,
    },
  },
});

const customTheme = darkTheme({
  accentColor: "#00d4aa",
  accentColorForeground: "#0a0b14",
  borderRadius: "large",
  fontStack: "system",
  overlayBlur: "small",
});

customTheme.colors.modalBackground = "#12131f";
customTheme.colors.modalBorder = "rgba(255,255,255,0.08)";
customTheme.colors.profileForeground = "#12131f";
customTheme.colors.connectButtonBackground = "rgba(255,255,255,0.03)";

interface Web3ProviderProps {
  children: ReactNode;
}

export function Web3Provider({ children }: Web3ProviderProps) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={customTheme} modalSize="compact">
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
